import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FauxSelectMetaDropdownComponent } from 'src/modules/faux-select-meta-dropdown/faux-select-meta-dropdown.component';


@NgModule({
  declarations: [
    FauxSelectMetaDropdownComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    FauxSelectMetaDropdownComponent
  ]
})
export class FauxSelectMetaDropdownModule { }
